import { ref, onValue } from 'firebase/database';
import StartFirebase from './index';

const db = StartFirebase();

export const milefetchData = async() => {
    let records = [];
    onValue(ref(db), (snapshot) => {
        Object.keys(snapshot.val()).forEach((key) => {
            const snapshotData = snapshot.val()[key];
            records.push({"key": key,"data": snapshotData});
        });
    });

    return records;
}